





























import mixins from 'vue-typed-mixins'
import {
  ScriptRowTestDesktop,
  ScriptRowTestTablet,
  ScriptRowTestMobile,
} from '@/components/Scripts/ScriptRowTest/ScriptRowTest'
import Collapse from '@/components/Collapse/Collapse.vue'
import Slider, { SliderItem } from '@/components/Slider/Slider.vue'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import { ScriptUnit } from '@/models/scripts'

interface Computed {
  showClass: string
  rowComponentName: string
  isScrollable: boolean
  isShowAsSlider: boolean
}

interface Props {
  show?: boolean
  item: ScriptUnit
}

export default mixins(WindowResizeListener).extend<{}, {}, Computed, Props>({
  components: {
    Collapse,
    Slider,
    SliderItem,
    ScriptRowTestDesktop,
    ScriptRowTestTablet,
    ScriptRowTestMobile,
  },
  props: {
    show: {
      default: false,
    },
    item: {
      required: true,
    },
  },
  computed: {
    showClass(): string {
      return this.show ? '-show' : ''
    },
    isScrollable(): boolean {
      return !!this.item.tests && this.item.tests.length > 1
    },
    rowComponentName(): string {
      if (this.isDesktop) {
        return 'ScriptRowTestDesktop'
      }
      if (this.isTablet) {
        return 'ScriptRowTestTablet'
      }
      return 'ScriptRowTestMobile'
    },
    isShowAsSlider(): boolean {
      return this.isMobile && this.isScrollable
    },
  },
})
